module.exports = __webpack_public_path__ + "static/media/circle.7d926fb0.svg";